import React from 'react';
import { useSelector } from 'react-redux';
import { FontIcon, ListItem, Divider } from 'material-ui';
import { map, sortBy } from 'lodash';

const styles = {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 20px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 10,
    paddingBottom: 10,
  },
  link: {
    marginTop: 12,
    marginBottom: 12,
    paddingLeft: 0,
  },
  tag: {
    marginTop: 12,
    borderRadius: 4,
    padding: 6,
    color: 'white',
    display: 'table',
  },
};

const TLinks = () => {
  const { links } = useSelector(state => state.WebValuesReducer);
  const sorted = sortBy(links, 'WebValueID');

  return (
    <div style={styles.container}>
      {map(sorted, link => (
        <div key={link.Code}>
          <ListItem
            rightIcon={<FontIcon className="material-icons">link</FontIcon>}
            innerDivStyle={styles.link}
            target="_blank"
            href={link.Value}
            primaryText={link.Description}
            hoverColor="transparent"
          />
          <Divider />
        </div>
      ))}
    </div>
  );
};

export default TLinks;



// WEBPACK FOOTER //
// ./src/containers/tiles/TLinks.js